import React from 'react'

import * as S from './border-loader.styled'
import { BorderLoaderProps } from './border-loader.types'

export const BorderLoader = ({
  size = 'medium',
  color = 'currentColor',
  align = 'unset',
  ...rest
}: BorderLoaderProps) => {
  return (
    <S.BorderLoader
      {...rest}
      $align={align}
      $size={size}
      $color={color}
      data-component-id="BorderLoader"
    />
  )
}
